export const HOME = '/';
export const DASHBOARD = "/dashboard"